import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import PropTypes from 'prop-types';
import { display, space, width, minWidth, maxWidth, height, minHeight, maxHeight, textAlign, flexBasis, flexDirection, flexWrap, flex, overflow } from 'styled-system';
export var WrapperProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, display.propTypes), space.propTypes), width.propTypes), minWidth.propTypes), maxWidth.propTypes), height.propTypes), minHeight.propTypes), maxHeight.propTypes), textAlign.propTypes), flexBasis.propTypes), flexDirection.propTypes), flexWrap.propTypes), flex.propTypes), overflow.propTypes);
export var ResponsiveSizeProps = PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]);
var RatingRangeProps = PropTypes.oneOf([].concat(_toConsumableArray(_toConsumableArray(new Array(11)).map(function (_, i) {
  return i / 2;
})), _toConsumableArray(_toConsumableArray(new Array(11)).map(function (_, i) {
  return (i / 2).toString();
}))));
export var TooltipProps = {
  children: PropTypes.node.isRequired,
  pointerPosition: PropTypes.string,
  pointerDirection: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  colorMode: PropTypes.string,
  onClose: PropTypes.func,
  fixedCloseButton: PropTypes.bool,
  'data-testid': PropTypes.string,
  whiteSpace: PropTypes.string
};
export var StarRatingProps = {
  rating: RatingRangeProps,
  ratingType: PropTypes.oneOf(['AAA', 'SELF_RATED']),
  size: ResponsiveSizeProps,
  tooltip: PropTypes.shape(TooltipProps),
  tooltipWrapper: PropTypes.shape(WrapperProps),
  onTooltipChange: PropTypes.func,
  excludeTitle: PropTypes.bool
};